import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { DRAWER_MODES } from '@/store/modules/leftSideDrawer/state';

const buildGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const isLeftSideDrawerOpen = buildGetterObject('isLeftSideDrawerOpen');
export const leftSideDrawerState = buildGetterObject('leftSideDrawerState');
export const isLeftDrawerTestMode = buildGetterObject('isLeftDrawerTestMode');
export const isLeftDrawerEditMode = buildGetterObject('isLeftDrawerEditMode');

const getters = {
	[isLeftSideDrawerOpen.getter]: (state) => !!state.leftSideDrawerState,
	[leftSideDrawerState.getter]: (state) => state.leftSideDrawerState,
	[isLeftDrawerTestMode.getter]: (state) => state.leftSideDrawerState === DRAWER_MODES.test,
	[isLeftDrawerEditMode.getter]: (state) => state.leftSideDrawerState === DRAWER_MODES.edit,
};

export default getters;
